import React from 'react';
import { useTranslation } from 'react-i18next';
import { getTimezone } from '@urc-ui/services/app-context';
import { useLocalizedDate } from '@urc-ui/hooks/i18n';
import { SINGLE_BRACKET_INTERPOLATION_OPTION } from '@urc-ui/utils/i18n-constants';
import styled from 'styled-components';
import { Alert } from '@amzn/storm-ui-v3';
import { isValidDate } from '@urc-ui/utils/date-utils';

const StyledAlert = styled(Alert)`
  margin: ${({ theme }) => theme.spacing.base};
`;

export function PreOutageBanner(props: { start: string; end: string }) {
  const { t: translate } = useTranslation();

  const startDate = new Date(props.start);
  const endDate = new Date(props.end);
  const timeZone = getTimezone();

  const [monthDate, startTime, endTime] = useLocalizedDate([
    {
      value: startDate,
      format: {
        day: 'numeric',
        month: 'short',
        timeZone
      }
    },
    {
      value: startDate,
      format: {
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
        timeZone
      }
    },
    {
      value: endDate,
      format: {
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
        timeZone
      }
    }
  ]);

  if (!props.start || !isValidDate(startDate) || !props.end || !isValidDate(endDate)) {
    throw new Error(`Invalid start or end date supplied to PreOutageBanner: ${props.start} ${props.end}`);
  }

  const headerText = translate('sspa_rcm_ad_reports_pre_outage_header', 'Upcoming report center maintenance');
  const descriptionText = translate(
    'sspa_rcm_ad_reports_pre_outage_description_interpolate',
    "The report center won't be available on {monthDate} from {startTime} to {endTime}. We're sorry for the inconvenience.",
    {
      monthDate,
      startTime,
      endTime,
      interpolation: SINGLE_BRACKET_INTERPOLATION_OPTION
    }
  );
  return (
    <StyledAlert id='pre-outage-banner' type='info' header={headerText}>
      {descriptionText}
    </StyledAlert>
  );
}
